interface Address {
  langcode: string;
  country_code: string;
  administrative_area: string;
  locality: string;
  postal_code: string;
  address_line1: string;
  address_line2: string;
}

interface BannerImage {
  url: string;
  alt: string;
  width: number;
  height: number;
}

interface Path {
  alias: string;
}

interface Description {
  summary: string;
  processed: string;
  value: string;
}

interface FieldColor {
  color: string;
}

interface FieldLogo {
  url: string;
}

interface Brand {
  name: string;
  brand_code: string;
  description: Description;
  path: Path;
  field_color: FieldColor;
  relationships: {
    field_logo: FieldLogo;
  };
}

interface HotelCardAmenity {
  name: string;
  machine_name: string;
}

interface Coordinates {
  latitude: number;
  longitude: number;
}
interface Tag {
  name: string;
}
interface Hotel {
  hotelId: string;
  uniqueIdentifier: string;
  name: string;
  crs_code: string;
  crs_name: string;
  hotel_code: string;
  field_occupancy_messaging: string;
  field_phone_require: string;
  address: Address;
  banner_images: BannerImage[];
  phone: string;
  path: Path;
  relationships: {
    brand_id: Brand;
    field_tags: Tag;
  };
  hotelCardAmenities: HotelCardAmenity[];
  placeId: string;
  coordinates: Coordinates;
  secondaryCity: string;
  smartScore: number;
  tagline: string;
}

interface HotelsData {
  allHotel: {
    nodes: Hotel[];
  };
}
import { useStaticQuery, graphql } from "gatsby";

export const useHotels = (): Hotel[] => {
  const hotels: HotelsData = useStaticQuery(graphql`
    {
      allHotel {
        nodes {
          hotelId: drupal_internal__id
          uniqueIdentifier: drupal_id
          name
          crs_code
          crs_name
          hotel_code
          field_occupancy_messaging
          field_phone_require
          address {
            langcode
            country_code
            administrative_area
            locality
            postal_code
            address_line1
            address_line2
          }
          banner_images {
            url
            alt
            width
            height
          }
          phone
          path {
            alias
          }
          galleryImages: gallery_images {
            alt
            url
          }
          relationships {
            field_tags {
              name
            }
            brand_id {
              name
              brand_code
              description {
                summary
                processed
                value
              }
              path {
                alias
              }
              field_color {
                color
              }
              relationships {
                field_logo {
                  url
                }
              }
            }
            hotelFeatures: field_features {
              field_feature_tab_title
              field_feature_title
              field_video_url
              field_feature_description {
                value
              }
              relationships {
                field_sites {
                  machine_name
                }
                field_feature_image_media {
                  relationships {
                    field_media_image_5 {
                      uri {
                        url
                      }
                      gatsbyImage(
                        width: 1920
                        height: 400
                        placeholder: BLURRED
                        formats: [AUTO, WEBP]
                      )
                    }
                  }
                }
                field_sub_feature {
                  field_feature_description {
                    value
                  }
                  field_feature_tab_title
                  field_feature_title
                  field_video_url
                  relationships {
                    field_feature_image_media {
                      relationships {
                        field_media_image_5 {
                          uri {
                            url
                          }
                          gatsbyImage(
                            width: 1920
                            height: 400
                            placeholder: BLURRED
                            formats: [AUTO, WEBP]
                          )
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          hotelCardAmenities: amenities {
            name
            machine_name
          }
          placeId: field_googl
          coordinates: lat_lon {
            latitude: lat
            longitude: lon
          }
          secondaryCity: field_secondary_city
          smartScore: field_smart_score_city
          tagline: field_tagline
        }
      }
    }
  `);
  // let hotelsByCode = convertArrayToObject(hotels.allHotel.nodes, 'hotel_code');
  return hotels.allHotel.nodes;
};
